import {
  labelDelete,
  labelUpdate,
  modalConfirmDeleteUser,
  modalConfirmDeleteUserSubtitle,
  snackbarUserDeleted,
  snackbarUserDeletedSubTitle,
} from "_constants";
import { useConfirmDialogExit } from "hooks";
import { User } from "interfaces";
import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { useSnackbar } from "providers/SnackbarProvider";
import { useRef } from "react";
import { deleteUser } from "services";
import { setPageUtenti } from "store/slicer/GestioneUsersSlice";
import { useAppDispatch } from "store/store";

export const UsersTableRowButtonActions = ({
  user,
  editCallback,
}: {
  user: User;
  editCallback: Function;
}) => {
  const dispatch = useAppDispatch();
  const { showSnackbar } = useSnackbar();
  const { showConfirmDialogDelete } = useConfirmDialogExit();
  const menuRight = useRef<any>(null);
  const items = [
    {
      label: labelUpdate,
      icon: PrimeIcons.PENCIL,
      command: () => {
        editCallback(user);
      },
    },
    {
      label: labelDelete,
      icon: PrimeIcons.TRASH,
      className: "p-menu-item-custom delete-color",
      command: () => {
        showConfirmDialogDelete({
          title: modalConfirmDeleteUser,
          subtitle: modalConfirmDeleteUserSubtitle,
          rejectCallback: callDeleteUser,
        });
      },
    },
  ];

  const callDeleteUser = () => {
    if (user?.id) {
      deleteUser(user.id!)
        .then((_) => {
          showSnackbar({
            severity: "success",
            summary: snackbarUserDeleted,
            detail: snackbarUserDeletedSubTitle,
            life: 5000,
          });
          dispatch(setPageUtenti(-1));
          setTimeout(() => {
            dispatch(setPageUtenti(1));
          }, 200);
        })
        .catch((_) => {});
    }
  };

  return (
    <>
      <Menu
        model={items}
        popup
        ref={menuRight}
        id="popup_menu_right"
        className="p-menu-custom-logout"
        popupAlignment="right"
      />
      <Button
        icon={PrimeIcons.ELLIPSIS_V}
        text
        severity="secondary"
        onClick={(event) => menuRight?.current?.toggle(event)}
      />
    </>
  );
};
